/* eslint-disable react/prop-types */
import { CardContent, Grid, Typography } from '@mui/material';
import SimpleCard from '../../../../../components/SimpleCard';
import FeaturesCheckBoxes from './FeaturesCheckBoxes';

export default function Amenities({
  cleanedFeatures,
  handleChangeCheckBoxes,
  selectedFeatures,
  totalPriceSelectedAmenities,
}) {
  return (
    <SimpleCard variant="outlined">
      <CardContent>
        <Grid container marginBottom={2}>
          <Grid item>
            <Typography fontWeight="bold">Surcharges:</Typography>
          </Grid>
          <Grid item>
            <Typography marginLeft={2}>features offered for an additional cost</Typography>
          </Grid>
        </Grid>
        <Grid container justifyContent="center">
          <Grid item xs={12} lg={8}>
            <FeaturesCheckBoxes
              features={cleanedFeatures}
              handleChange={handleChangeCheckBoxes}
              selectedFeatures={selectedFeatures}
            />
          </Grid>
        </Grid>

        <Grid container justifyContent="center">
          <Grid item>
            <Typography fontWeight="bold">Selected amenities:</Typography>
          </Grid>
          <Grid item>
            <Typography marginLeft={2} color="#0997BA">
              $ {totalPriceSelectedAmenities} USD
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </SimpleCard>
  );
}
